import { TOGGLE_SELECT_DEVICE } from '../constants/actionTypes';
import { DevicesActionTypes } from '../device/devicesActions';

export const toggleSelectDevice = (deviceId: string): DevicesActionTypes => ({
  type: TOGGLE_SELECT_DEVICE,
  payload: deviceId,
});
